import { fetchData } from "../fetchData";
import { postRequest } from "../httpMethods";

export const postAddTeacher = (payload) =>
    postRequest(`school/teachers`, payload);

export const postAssignCourseToTeachers = (payload) =>
    postRequest(`school/assign-course`, payload);

export const postSchoolSignup = (payload) =>
    postRequest("school-signup", payload);

export const getCheckDetails = (type, mobile) =>
    fetchData(`user/checkDetails?type=${type}&mobile=${encodeURIComponent(mobile)}`);

export const postSendOtp = (payload) =>
    postRequest("send-otp-sv", payload);

export const postRoleCheck = (identifier) =>
    postRequest("auth/role-check", { identifier });

export const postTeacherSignUp = (identifier) =>
    postRequest("teachers/signup",  identifier );

export const postLogin = (loginRoute, payload) =>
    postRequest(loginRoute, payload);

// Keys must match role-check API response role values exactly (lowercase)
export const LOGIN_ROUTE_BY_ROLE = {
    teacher: "teachers/login",
    school: "school-login",
    student: "collab-login",
    user: "collab-login",
    publisher_sme: "collab-login",  // 👈 add any new roles here

};

